<template>
  <div id="app">
    <Header ></Header>
    <router-view v-if="isRouterAlive"/>
    <div class="app-top" @click='gototop' v-show='btnFlag'><img class='app-topimg' src="@/static/images/top.png" alt=""></div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  components: {
    Footer,
    Header
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  data () {
    return {
      btnFlag: false,
      isRouterAlive: true
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  methods: {
    gototop () {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    }, // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 0) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
    reload () {
      console.log('in reload')
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
#app {
  min-width: 1180px;
  min-height: 70vh;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  overflow: hidden;
  padding-bottom: 358px;
}
.header {
  width: 100%;
}
.app-top{
  width:54px;
  height:52px;
  background:rgba(39,39,39,.7);
  position: fixed;
  right:0;
  top:30%;
  z-index:99999;
}
.app-topimg{
  width:54px;
  height:52px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue